export default __webpack_public_path__ + "static/media/twitter (1)@1.5x.06a83825.svg";